
// Configurazione Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCjuhROaBSKJJ_qZmaTgz6dVorwZqm_d_4",
  authDomain: "appguide-a0356.firebaseapp.com",
  projectId: "appguide-a0356",
  storageBucket: "appguide-a0356.appspot.com",
  messagingSenderId: "503011572850",
  appId: "1:503011572850:web:afc0f559b1a62ff397d6eb",
   measurementId: "G-FSPBVBGFM7"
};


export {  firebaseConfig};
  